import { useMiniSite } from "../../components/minisite/context";
import { MiniSitePolicies } from "../RentalProfile";

const ADDITIONAL_TEXT_FIELDS = [
  { key: "terms_text",         label: "Terms & conditions" },
  { key: "privacy_text",       label: "Privacy" },
  { key: "refund_policy_text", label: "Refund policy" },
];

export default function MiniSitePoliciesPage() {
  const { data, theme } = useMiniSite();
  const ms = data.mini_site || {};
  const policies = ms.policies || {};
  const hasAnyShortPolicy = Object.values(policies).some((v) => !!v);
  const longForm = ADDITIONAL_TEXT_FIELDS.filter((f) => ms[f.key]);
  const empty = !hasAnyShortPolicy && longForm.length === 0;

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="ms-policies-page">
      <h1 className="font-display text-3xl sm:text-4xl font-bold" style={{ color: theme }}>
        Policies
      </h1>

      {empty && (
        <p className="text-slate-500 italic mt-3" data-testid="ms-policies-empty">
          The business hasn&apos;t published rental policies yet. Please contact them directly for details.
        </p>
      )}

      {hasAnyShortPolicy && (
        <div className="mt-4">
          <MiniSitePolicies ms={ms} theme={theme} enabled={true} />
        </div>
      )}

      {longForm.map((f) => (
        <section key={f.key} className="mt-6 rounded-xl border border-slate-200 bg-white p-5" data-testid={`ms-policy-text-${f.key}`}>
          <h2 className="font-display text-xl font-semibold" style={{ color: theme }}>{f.label}</h2>
          <p className="text-sm text-slate-700 whitespace-pre-line mt-2 leading-relaxed">{ms[f.key]}</p>
        </section>
      ))}

      <p className="text-xs text-slate-500 italic mt-6 max-w-3xl">
        ConfirmPH provides tools to help businesses display and organize policies.
        The rental business remains responsible for its own terms, policies, and legal compliance.
      </p>
    </div>
  );
}
